<script setup lang="ts">
import { Banner } from '@dashhudson/dashing-ui/banner';
import { useCssVar, useElementSize } from '@vueuse/core';
import { computed, useTemplateRef, watch } from 'vue';

import { useOutageBanners } from '@/composables/useOutageBanners';

const { visibleBanners, closeBanner } = useOutageBanners();

const showOutageBanners = computed(() => visibleBanners.value.length > 0);

const rootRef = useTemplateRef('root');
const { height } = useElementSize(rootRef);

const outageOffset =
  typeof document === 'undefined'
    ? { value: '0px' }
    : useCssVar('--dash-top-banner-offset-outage', document.documentElement);

watch(
  [showOutageBanners, height],
  () => {
    outageOffset.value = showOutageBanners.value ? `${Math.ceil(height.value)}px` : '0px';
  },
  { immediate: true },
);
</script>

<template>
  <div
    v-if="showOutageBanners"
    ref="root"
    class="fixed! top-0! right-0! left-0! z-1000"
    data-exclude-side-panel-close
  >
    <Banner
      v-for="banner in visibleBanners"
      :key="banner.id"
      :title="banner.title"
      :message="banner.message"
      :severity="banner.severity"
      class="w-full"
      @close="() => closeBanner(banner.id)"
      @action="() => {}"
    />
  </div>
</template>
